var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKedyAiCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 187,
    viewBox: "0 0 69 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8907 107.738C4.03261 100.078 -0.59728 89.8579 0.0627963 81.6634C0.455682 76.7886 1.35711 71.9684 2.39642 67.1891C3.06153 64.1322 3.78552 61.0789 4.86003 58.1405C5.8505 56.1596 6.52637 54.0127 7.53911 52.026C8.57268 49.9977 9.71973 48.0289 10.9472 46.1119C13.2837 42.4639 15.8457 38.3641 19.08 35.4832C18.0924 35.4472 17.2428 35.0565 16.3105 34.8389C15.5204 34.6543 14.8373 34.497 14.137 34.0402C12.7989 33.1668 11.7998 31.6908 11.7732 30.0596C11.7395 27.9788 13.097 25.6704 11.8809 23.9817C11.5333 23.4998 11.0176 23.1622 10.6542 22.6918C9.84976 21.6524 9.93738 20.1542 10.4244 18.9331C10.9113 17.7128 11.7359 16.6606 12.3565 15.502C12.7989 14.676 12.8484 14.513 12.4642 13.6583C11.9729 12.5672 10.8574 11.9266 9.89066 11.2212C8.92389 10.5159 7.97509 9.49383 8.10007 8.30368C11.3157 7.8914 14.7547 9.80124 17.7067 8.46241C17.8999 8.37478 18.0946 8.26777 18.2146 8.09251C18.42 7.793 18.3496 7.39006 18.2655 7.03668C17.7506 4.87401 17.0589 2.41471 18.3101 0.578127C18.481 0.327456 18.7044 0.0861229 18.9996 0.0193252C19.2452 -0.0359804 19.5002 0.0372839 19.7394 0.114855C21.9969 0.847475 23.5562 2.02254 25.3856 3.35778C27.3148 4.76699 29.8704 4.31808 32.1314 4.60467C35.1977 4.99396 37.9543 6.65241 40.4208 8.51485C42.8873 10.3773 45.1843 12.4904 47.8677 14.0246C51.395 16.0407 55.5451 17.0326 58.6027 19.7074C62.7262 23.3145 63.9702 29.1826 64.3337 34.6486C64.6964 40.1066 66.0977 44.9519 67.4645 50.2483C68.2439 53.2693 68.6123 56.3959 68.5556 59.5145C68.4895 63.1748 69.0045 67.4721 68.5556 71.1072C68.5556 95.1688 60.0141 90.0253 52.0817 102.229C50.6588 104.418 49.1922 106.733 49.014 109.338C48.7418 113.311 51.4748 116.774 53.9046 119.929C59.6119 127.341 64.5003 135.571 66.7679 144.646C69.0361 153.721 68.478 163.746 63.851 171.876C58.7442 180.849 48.7152 186.806 38.3917 186.995C34.9104 187.059 31.2983 186.463 28.4159 184.509C25.5336 182.554 23.5483 179.032 24.1366 175.6C25.0976 169.991 35.393 169.732 39.6156 165.917C44.3611 161.63 45.9686 152.918 46.0807 146.524C46.1927 140.13 44.3597 135.474 42.7451 129.286C42.0778 126.73 38.2251 122.357 36.4496 120.401C31.8693 115.357 23.6553 117.692 16.9447 116.509C12.8018 115.782 12.4017 111.021 9.8907 107.738Z",
    fill: "url(#paint0_linear_163_88)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_163_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6151 71.8891C57.9484 72.6589 57.9484 74.5834 56.6151 75.3532L27.6002 92.1049C26.2669 92.8747 24.6002 91.9125 24.6002 90.3729L24.6002 56.8693C24.6002 55.3297 26.2669 54.3675 27.6002 55.1373L56.6151 71.8891Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_163_88",
    x: 24.6002,
    y: 54.8663,
    width: 37.015,
    height: 41.5095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_163_88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_88",
    x1: 68.7412,
    y1: 93.5,
    x2: 0,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302885,
    stopColor: "#175CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D337F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKedyAiCat);
export default __webpack_public_path__ + "static/media/kedy-ai-cat.2d1ef94c7f0eb2631028fb013a004e82.svg";
export { ForwardRef as ReactComponent };